const PlayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M8 5v14l11-7z"/>
    </svg>
);

const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
    </svg>
);

const VideoPage = ({ attributes, onBack }) => {
    const { videoPage = {}, primaryColor = '#ff0037' } = attributes;
    const {
        showHeader = true,
        headerText = 'Corporate Video',
        title = 'Watch Our Story',
        videoType = 'youtube',
        youtubeUrl = '',
        uploadVideoUrl = '',
        posterImage = '',
        showButton = true,
        buttonText = 'Back to Home',
        videoWidth = '100%',
        videoHeight = 'auto',
        autoplay = false,
        controls = true,
        muted = false,
        loop = false,
        // videos = []
    } = videoPage;

    const handleBack = () => {
        if (onBack) {
            onBack();
        }
    };

    // Extract YouTube video ID from various URL formats
    const getYouTubeId = (url) => {
        if (!url) return null;
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    };

    const youtubeId = videoType === 'youtube' ? getYouTubeId(youtubeUrl) : null;
    const embedUrl = youtubeId ? `https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1${autoplay ? '&autoplay=1' : ''}${muted ? '&mute=1' : ''}${loop ? '&loop=1' : ''}` : '';
    // const galleryVideos = Array.isArray(videos) ? videos : [];

    return (
        <div className="gmf-video-page-wrapper">
            <div className="gmf-video-page-container">
                {/* Breadcrumb */}
                <div className="gmf-video-page-breadcrumb">
                    <span className="gmf-video-page-breadcrumb-home" onClick={handleBack}>
                        Home
                    </span>
                    <span className="gmf-video-page-breadcrumb-sep">/</span>
                    <span className="gmf-video-page-breadcrumb-current">{title || 'Video'}</span>
                </div>

                {/* Header Section */}
                {showHeader && (
                    <div className="gmf-video-page-header">
                        {headerText && (
                            <span className="gmf-video-page-header-label" style={{ color: primaryColor }}>
                                {headerText}
                            </span>
                        )}
                        <h1 className="gmf-video-page-title">{title}</h1>
                    </div>
                )}

                {/* Video Player Section */}
                <div className="gmf-video-player-section">
                    {videoType === 'youtube' && youtubeId ? (
                        <div className="gmf-video-player-container">
                            <iframe
                                className="gmf-video-player-iframe"
                                src={embedUrl}
                                title={title}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                style={{
                                    width: videoWidth,
                                    height: videoHeight === 'auto' ? '100%' : videoHeight,
                                    aspectRatio: videoHeight === 'auto' ? '16/9' : undefined
                                }}
                            ></iframe>
                        </div>
                    ) : videoType === 'upload' && uploadVideoUrl ? (
                        <div className="gmf-video-player-container">
                            <video
                                className="gmf-video-player-native"
                                src={uploadVideoUrl}
                                poster={posterImage || ''}
                                controls={controls}
                                autoPlay={autoplay}
                                muted={muted}
                                loop={loop}
                                playsInline
                                style={{
                                    width: videoWidth,
                                    height: videoHeight === 'auto' ? '100%' : videoHeight,
                                    aspectRatio: videoHeight === 'auto' ? '16/9' : undefined
                                }}
                            >
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    ) : (
                        <div className="gmf-video-player-placeholder">
                            <div className="gmf-video-player-placeholder-icon" style={{ color: primaryColor }}>
                                <PlayIcon />
                            </div>
                            <p className="gmf-video-player-placeholder-text">
                                No video configured. Please add a video URL in the settings.
                            </p>
                        </div>
                    )}
                </div>

                {/* Back Button */}
                {showButton && (
                    <div className="gmf-video-page-back">
                        <button
                            className="gmf-video-page-back-btn"
                            onClick={handleBack}
                            style={{ backgroundColor: primaryColor }}
                        >
                            {/* {buttonIcon && <img src={buttonIcon} alt="" className="gmf-video-page-back-icon" />} */}
                            <ArrowLeftIcon />
                            {buttonText}
                        </button>
                    </div>
                )}

                {/* {galleryVideos.length > 0 && (
                    <section style={{ marginTop: 36 }}>
                        <h2 style={{ marginBottom: 16, fontSize: '1.3rem' }}>Media Gallery</h2>
                        <div style={{ display: 'grid', gap: 18 }}>
                            {galleryVideos.map((item, index) => {
                                const itemType = item.videoType || 'youtube';
                                const itemYoutubeId = itemType === 'youtube' ? getYouTubeId(item.youtubeUrl || '') : null;
                                const itemEmbedUrl = itemYoutubeId
                                    ? `https://www.youtube.com/embed/${itemYoutubeId}?rel=0&modestbranding=1`
                                    : '';
                                return (
                                    <article key={item.id || index} className="gmf-privacy-section-card">
                                        {item.title ? <h3 className="gmf-privacy-section-title" style={{ marginBottom: 10 }}>{item.title}</h3> : null}
                                        {itemType === 'youtube' && itemEmbedUrl ? (
                                            <div className="gmf-video-player-container" style={{ marginBottom: 10 }}>
                                                <iframe
                                                    className="gmf-video-player-iframe"
                                                    src={itemEmbedUrl}
                                                    title={item.title || `Video ${index + 1}`}
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    allowFullScreen
                                                ></iframe>
                                            </div>
                                        ) : itemType === 'upload' && item.uploadVideoUrl ? (
                                            <div className="gmf-video-player-container" style={{ marginBottom: 10 }}>
                                                <video className="gmf-video-player-native" src={item.uploadVideoUrl} poster={item.posterImage || ''} controls playsInline>
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        ) : (
                                            <p style={{ opacity: 0.8 }}>Video URL is not configured.</p>
                                        )}
                                        {item.description ? <p>{item.description}</p> : null}
                                    </article>
                                );
                            })}
                        </div>
                    </section>
                )} */}
            </div>
        </div>
    );
};

export default VideoPage;
